<template>
  <div class="container">
    <div class="production-container">
      <div class="production-section">
        <el-form
          label-position="right"
          label-width="100px"
          :model="createForm"
          ref="createForm"
          :rules="rules"
        >
          <div class="production_data-section">
            <p class="header-title">上传学生作品</p>
            <div class="body">
              <div class="link">
                <el-form-item label="诗名" prop="poetry_name">
                  <el-input
                    size="mini"
                    v-model="createForm.poetry_name"
                  ></el-input>
                </el-form-item>
                <el-form-item label="作者姓名" prop="author">
                  <el-input size="mini" v-model="createForm.author"></el-input>
                </el-form-item>
              </div>
              <div class="link">
                <el-form-item
                  label="学校"
                  prop="school_name"
                  :show-message="false"
                >
                  <!-- <el-select
                    size="mini"
                    v-model="createForm.school_id"
                    filterable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in schoolData"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select> -->
                  <el-input
                    size="mini"
                    v-model="createForm.school_name"
                    disabled
                  ></el-input>
                </el-form-item>
                <el-form-item label="指导教师" prop="teacher_name">
                  <el-input
                    size="mini"
                    v-model="createForm.teacher_name"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="link">
                <el-form-item label="年龄" prop="age">
                  <el-input
                    size="mini"
                    v-model.number="createForm.age"
                  ></el-input>
                </el-form-item>
                <el-form-item label="当前班级" prop="grade_id">
                  <el-select
                    size="mini"
                    v-model="createForm.grade_id"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in gradeData"
                      :key="item.id"
                      :label="item.class_name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="link">
                <el-form-item label="作品所属季节" prop="season_id">
                  <el-select
                    size="mini"
                    v-model="createForm.season_id"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in seasonData"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="production_content-section">
            <p class="production_content-section_header header-title">
              诗歌创作背景
            </p>
            <div class="production_content-section_content">
              <el-form-item prop="poetry_content">
                <quill-editor
                  class="quill-editor"
                  v-model="createForm.poetry_content"
                  ref="myQuillEditor"
                  :options="editorOption"
                >
                </quill-editor>
              </el-form-item>
            </div>
          </div>
          <div class="production_image-section">
            <p class="production_image-section_header header-title">上传作品</p>
            <el-form-item prop="image_url">
              <el-upload
                action=""
                class="avatar-uploader"
                :show-file-list="false"
                :http-request="uploadImage"
                :before-upload="beforeAvatarUpload"
                :loading="uploading"
              >
                <img
                  v-if="createForm.image_url"
                  :src="createForm.image_url"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </div>
        </el-form>
        <div class="production_save-section">
          <router-link :to="{ name: 'my_student_production' }">
            <el-button size="medium">返回</el-button>
          </router-link>
          <el-button @click="handleSubmit" size="medium">保存</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import userService from "@/global/service/user";
import ossService from "@/global/service/oss";
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"],
  ["blockquote", "code-block"],
  [{ header: 1 }, { header: 2 }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ direction: "rtl" }],
  [{ size: ["small", false, "large", "huge"] }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [] }, { background: [] }],
  [{ align: [] }],
  ["clean"]
];
export default {
  data() {
    return {
      rules: {
        age: [
          { required: true, message: "请输入年龄", trigger: "blur" },
          { type: "number", message: "年龄必须为数字值" }
        ],
        poetry_name: [
          { required: true, message: "请输入诗名", trigger: "blur" }
        ],
        author: [{ required: true, message: "请输入作者名", trigger: "blur" }],
        teacher_name: [
          { required: true, message: "请填写老师名称", trigger: "blur" }
        ],
        school_name: [{ required: true }],
        grade_id: [
          { required: true, message: "请选择当前年级", trigger: "change" }
        ],
        season_id: [
          { required: true, message: "请选择作品季节", trigger: "change" }
        ],
        poetry_content: [
          { required: true, message: "请填写诗歌创作背景", trigger: "blur" }
        ],
        image_url: [{ required: true, message: "请上传作品", trigger: "blur" }]
      },
      schoolData: [],
      seasonData: [
        { id: 1, name: "春" },
        { id: 2, name: "夏" },
        { id: 3, name: "秋" },
        { id: 4, name: "冬" }
      ],
      gradeData: [],
      createForm: {
        age: null,
        author: null,
        grade_id: null,
        image_url: null,
        poetry_content: null,
        poetry_name: null,
        school_name: null,
        season_id: null,
        teacher_name: null,
        file_id: null
      },
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions
          }
        }
      },
      uploading: false,
      imageType: ["jpg", "jpeg", "png"]
    };
  },
  components: {
    "quill-editor": quillEditor
  },
  created() {
    Promise.all([userService.classList()]).then(res => {
      this.createForm.school_name = res[0].school.name;
      this.gradeData = res[0].classrooms;
    });
  },
  methods: {
    handleSubmit() {
      const params = {
        poetry_name: this.createForm.poetry_name,
        author: this.createForm.author,
        age: this.createForm.age,
        teacher_name: this.createForm.teacher_name,
        classroom_id: this.createForm.grade_id,
        season_id: this.createForm.season_id,
        poetry_content: this.createForm.poetry_content,
        file_id: this.createForm.file_id
      };
      userService.studentWorkCreate(params).then(() => {
        this.$message.success("上传成功");
        this.$router.push({
          name: "my_student_production"
        });
      });
    },
    uploadImage(file) {
      this.uploading = true;
      ossService
        .upload({ file }, () => {})
        .then(res => {
          this.createForm.image_url = res.path;
          this.createForm.file_id = res.id;
        })
        .finally(() => {
          this.$message.success("上传成功");
          this.uploading = false;
        });
    },
    beforeAvatarUpload(file) {
      const type = file.name.split(".").pop();
      const imageRegex = new RegExp(`${this.imageType.join("|")}`, "i");
      const isJPG = imageRegex.test(type);
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG、PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-form-item__label {
  font-size: 12px !important;
}
/deep/ .el-select,
.el-select--minit {
  width: 100%;
}
/deep/.production_image-section
  .el-form-item.is-required
  .el-form-item__content {
  margin-left: 0 !important;
}
/deep/.production_content-section_content
  .el-form-item.is-required
  .el-form-item__content {
  margin: 0 20px 0 0px !important;
}
/deep/.ql-toolbar.ql-snow .ql-formats {
  margin: 0;
}
/deep/ .ql-picker-label {
  display: flex;
  align-items: center;
}

.container {
  background-color: #fff;
  padding: 20px;
  .body {
    .link {
      display: flex;
      justify-content: space-between;
      width: 100%;
      .el-form-item {
        width: 48%;
      }
    }
  }
  .production_content-section {
    .production_content-section_content {
      width: 100%;
      /deep/ .ql-editor {
        height: 240px;
      }
    }
  }
  .production_save-section .el-button {
    margin: 0 4px;
  }
}
.header-title {
  width: 100%;
  text-align: left;
  border-bottom: 1px solid #dedede;
  font-size: 12px;
  color: #999;
  line-height: 30px;
  margin-bottom: 20px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
</style>
